





























































import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { defineComponent, toRefs } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
    selected: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    round: { type: Boolean, default: false },
    completed: { type: Boolean, default: false },
    index: { type: Number, default: null },
    stepNumber: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const { disabled, index } = toRefs(props)

    const handleStepClick = () => {
      if (disabled.value) {
        return
      }
      emit('click', index.value)
    }
    return {
      handleStepClick,
      faCheck
    }
  }
})
